import { LogOut } from "lucide-react";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@eaigle/ui";
import { authService } from "@eaigle/api/authService";

type LogoutButtonProps = {
  variant?: "icon" | "labeled";
};

export function LogoutButton({ variant = "icon" }: LogoutButtonProps) {
  const handleLogout = (): void => {
    void authService.logout();
  };

  if (variant === "labeled") {
    return (
      <Button
        type="button"
        variant="secondary"
        onClick={handleLogout}
        leftIcon={<LogOut className="h-4 w-4" aria-hidden />}
      >
        Sign out
      </Button>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={handleLogout}
          aria-label="Sign out"
        >
          <LogOut className="h-4 w-4" aria-hidden />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Sign out</TooltipContent>
    </Tooltip>
  );
}
